import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root',
})
export class PrivateAdminGuardGuard implements CanActivate {
  constructor(
    public authService: AuthService,
    public router: Router,
    public dataService: DataService,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.getUser().pipe(
      take(1),
      switchMap(user => user ? this.authService.getUserData(user.uid) : of(null)),
      map((userData) => userData?.isAdmin),
    );
  }

}
